$(document).ready(function(){
	var $search_module = $('.section--search');
	if( $search_module.length > 0 ) {
		
		// DISPLAY SEARCH INDUSTRY SELECTOR IF INDUSTRY IS NOT SET & ANNOYING SEARCH POSITIONING
		if( ! user_data.industry ) {
			$search_module.find('.search-form-industry-wrapper').removeClass('d-none');
			$search_module.find('.search-count').addClass('d-lg-none');
			$search_module.find('.search-form-search-wrapper .search-count').removeClass('d-lg-none').addClass('d-lg-block');
		}
		
		// SET USER INDUSTRY BASED ON INDUSTRY 
		if( $search_module.find('[name="industry"]').val() ) {
			// CHANGE INDUSTRY
			if( user_data.industry.id && user_data.industry.id != $search_module.find('[name="industry"]').val() ) {
				$search_module.find('[name="industry"]').trigger('change');
				alert('Changing your industry to ' + user_data.industry.title);
			// UPDATE CHANGED INDUSTRY BASED ON URL PARAM
			} else if( get_url_param('industry') && user_data.industry.id && user_data.industry.id != get_url_param('industry') ) {
				$search_module.find('[name="industry"]').val( get_url_param('industry') ).trigger('change');
				alert('Changing your industry to ' + user_data.industry.title);
			// SET INDUSTRY FOR THE FIRST TIME BASED ON VALUE IN URL
			} else if( ! user_data.industry ) {
				$search_module.find('[name="industry"]').trigger('change');
			}
		}
		
		// RELOAD PAGE AFTER FILTERS ARE CLICKED
		$('[data-search-filter]').on('change', function(){
			if( $search_module.find('[name="search"]').val() ) {
				$search_module.addClass('loading');
				$search_module.find('form').submit();
			}
		})
		
		// LOAD MORE (VISUAL ONLY, NO AJAX)
		$('[search-load-more]').on('click', function(e){
			e.preventDefault();
			for( i = 0; i < 8; i++ ) {
				$('.search-item.d-none').first().removeClass('d-none');
			}
			$(window).trigger('resize');
			if( $('.search-item.d-none').length == 0 ) {
				$('[search-load-more]').hide();
			}
		})
		
		// FOCUS
		if( ! $search_module.find('[name="search"]').val() ) {
			$search_module.find('[name="search"]').focus()
		};
	}
});